







































































































































































































import { Vue, Component, Prop, Model, Watch } from "vue-property-decorator";
import {
	Uploader,
	Icon,
	Toast,
	Field,
	Tag,
	Dialog,
	CellGroup,
	Picker,
	Popup,
	ImagePreview,
	ActionSheet,
	Cell,
	RadioGroup,
	Radio,
	Checkbox,
	Switch,
} from "vant";
import Routers from "../../router/RouterTypes";
import {
	MUTATION_INTER_SET_DATA,
	MUTATION_INTER_INTERIM,
} from "../../store/StoreTypes";
import Public from "../../common/Public";
import Api from "../../api";
import store from "@/store";
import * as StoreType from "../../store/StoreTypes";
import ConsultTip from "@/views/Im/components/ConsultTip.vue";
import Cons from "@/common/Constants";
import ScConfirmBtn from "@/views/Im/components/ScConfirmBtn.vue";
import PayBackTip from "../../components/PayBackTip.vue";
import Wechat from "@/common/Wechat";
import { utils } from "@/components/medical-core";
import ChooseArrange from "../appointment/components/ChooseArrange.vue";
import { urlAuthBg } from "@/components/medical-component-mobile/directive/urlAuth";
import DoctorInfo from "../appointment/components/DoctorInfo.vue";
import { goPay } from "@/common/Fns";
import apis from "@/api";
import axios from "axios";
import {RegistTicket} from '@/api/common'

const CancelToken = axios.CancelToken;

interface caseItem {
	time: string;
	department: string;
	con: string;
	type: string;
	id: number;
	recordId: string;
}

Component.registerHooks(["beforeRouteEnter"]);
@Component({
	components: {
		[Icon.name]: Icon,
		[Uploader.name]: Uploader,
		[Field.name]: Field,
		[CellGroup.name]: CellGroup,
		[Tag.name]: Tag,
		[Picker.name]: Picker,
		[Popup.name]: Popup,
		[ActionSheet.name]: ActionSheet,
		[RadioGroup.name]: RadioGroup,
		[Radio.name]: Radio,
		[Cell.name]: Cell,
		[Checkbox.name]: Checkbox,
		[Switch.name]: Switch,
		ConsultTip,
		ScConfirmBtn,
		PayBackTip,
		ChooseArrange,
		DoctorInfo,
	},
	filters: {
		filterDeptName(val) {
			const maxlen = 6;
			if (val && val.length > maxlen) {
				return val.substring(0, maxlen) + "...";
			} else {
				return val;
			}
		},
		fliterDiagnosis(val) {
			const maxlen = 8;
			if (val && val.length > maxlen) {
				return val.substring(0, maxlen) + "...";
			} else {
				return val;
			}
		},
	},
})
export default class StartConsult extends Vue {
	async beforeRouteEnter(to, from, next) {
		let { fullPath } = to;
    	const registList = ['updateTimelineShareData', 'updateAppMessageShareData', 'onMenuShareAppMessage', 'onMenuShareTimeline', 'chooseImage', 'getLocalImgData', 'getLocation', 'openLocation']
		await store.dispatch(StoreType.ACTION_PATIENT_CARDLIST);
        RegistTicket(fullPath, registList);
		next();
	}

	payVisiable: boolean = false; //小程序支付弹框是否显示
	doctorMsg: any = {}; // 医生信息

	checked: boolean = true; // 问诊协议

	patientName = "";
	doctorName = "";
	inqueryId = "";
	showConsultTip = false;
	payShow = false;
	showChooseType: boolean = false; //选择初诊/复诊

	isAllowCallAhead: boolean = false; // 是否允许提前拨打电话

	activeIcon = require("../../assets/icon_choose_sel2@2x.png");
	inactiveIcon = require("../../assets/icon_weigouxuan.png");

	VISIT_TYPE_FIRST_CODE = Cons.VISIT_TYPE_FIRST_CODE;
	VISIT_TYPE_SECOND_CODE = Cons.VISIT_TYPE_SECOND_CODE;

	FIRST_INQUIRY_TYPE: string = Cons.FIRST_INQUIRY_TYPE;
	VISIT_INQUIRY_TYPE: string = Cons.VISIT_INQUIRY_TYPE;
	EASY_INQUIRY_TYPE: string = Cons.EASY_INQUIRY_TYPE;
	PICTURE_INQUIRY_TYPE: string = Cons.PICTURE_INQUIRY_TYPE;
	VIDEO_INQUIRY_TYPE: string = Cons.VIDEO_INQUIRY_TYPE;
	PHONE_INQUIRY_TYPE: string = Cons.PHONE_INQUIRY_TYPE;
	SPEED_INQUIRY_TYPE: string = Cons.SPEED_INQUIRY_TYPE;
	// 当前医院信息
	currentHospital: any = {}

	acographyType: any = "";

	Cons = Cons;
	//服务类型
	serviceType: string = "";

	depts: any = []; //当前医生所在的所有科室
	departmentId: string = ""; // 当前选中号源的科室id
	currentDept: any = {}; //当前号源取的科室
	showSchedule: boolean = false; //选择日期选择排班弹框
	schedulingList: any = []; //医生排班
	// 号源过期了，需要重新查询号源
	isQueryArrangeAgain = false;

	isLastDescClose: boolean = true; // 上次病情描述 是否关闭
	chief: string = "";
	urls: any = [];
	fileId: any = [];

	quickDept: any = "";
	quickTitleLevel: any = "";
	virtualDeptList: any = [];

	quickTitle_index: any = "";
	quickDept_index: any = "";

	isShowDoctorTitle: boolean = false;
	isShowQuickDept: boolean = false;

	doctorTitleOptions: any = [];

	cancelFnArr: any = [];
	problemValue: string = ""
	//是否区域版
	get isOrg() {
		return this.$store.getters[StoreType.IS_AREA_ORG];
	}

	get isShowDoctorInfo() {
		return this.inquiryType !== this.SPEED_INQUIRY_TYPE;
	}

	get isShowAcography() {
		return (
			this.inquiryType === this.PICTURE_INQUIRY_TYPE ||
			this.inquiryType === this.VIDEO_INQUIRY_TYPE ||
			this.inquiryType === this.VISIT_INQUIRY_TYPE
		);
	}

	get inquiryType() {
		return this.serviceType || this.$route.query.inquiryType || "10";
	}

	// 号源分时
	get timeShare() {
		return this.$store.state.doctor.timeShare;
	}

	get appoTime() {
		return (
			this.timeShare &&
			this.timeShare.scheduleDate +
				" " +
				this.timeShare.scheduleDetailStartTime +
				"-" +
				this.timeShare.scheduleDetailEndTime
		);
	}

	get videoInquiryAllow() {
		return this.doctorMsg.videoInquiryAllow;
	}

	get textInquiryAllow() {
		return this.doctorMsg.textInquiryAllow;
	}

	get PARAM_INQUIRY() {
		return this.$store.getters[StoreType.PARAM_INQUIRY];
	}

	get PARAM_CARD() {
		return {}; //this.$store.getters[StoreType.PARAM_CARD];
	}

	get PARAM_SPEED() {
		return this.$store.getters[StoreType.PARAM_SPEED];
	}

	get isTextArrange() {
		return false;
		return (
			this.PARAM_INQUIRY["imgTextScheduleEnable"] === 1 &&
			(this.inquiryType === this.PICTURE_INQUIRY_TYPE ||
				this.inquiryType === this.VIDEO_INQUIRY_TYPE ||
				this.inquiryType === "")
		);
	}

	get isPhoneArrange() {
		return this.PARAM_INQUIRY["phoneScheduleEnable"] === 1;
	}

	get isNeedArrange() {
		return false;
		return (
			this.inquiryType === this.VIDEO_INQUIRY_TYPE ||
			(this.inquiryType === this.PICTURE_INQUIRY_TYPE &&
				this.isTextArrange) ||
			this.inquiryType === this.VISIT_INQUIRY_TYPE ||
			(this.inquiryType === this.PHONE_INQUIRY_TYPE &&
				this.isPhoneArrange)
		);
	}

	// 是否显示排队号
	get isInquiryShowQueue() {
		return (
			this.$store.getters[StoreType.PARAM_INQUIRY][
				"inquiryShowQueueNumEnable"
			] == 1
		);
	}

	//当前医院是否启用就诊卡
	get isNeedJzk() {
		if (this.inquiryType === this.SPEED_INQUIRY_TYPE) {
			return false;
		}
		return this.PARAM_CARD["cardEnable"] === 1;
	}

	// 当前选中就诊人
	get currentPatient() {
    	return this.$store.state.patient.patientInfo;
	}

	// 判断是否通过
	get isPass(): boolean {
		let flag = true;
		if (utils.isNull(this.currentPatient)) {
			// 未选择就诊人
			flag = false;
		}

		if (
			this.inquiryType === Cons.VIDEO_INQUIRY_TYPE &&
			!this.isTextArrange
		) {
			if (!this.videoTimeString) {
				// 未选择视频问诊排班
				flag = false;
			}
		}

		//三亚版本,视频问诊未选择时间
		if (
			this.isTextArrange &&
			!this.videoTimeString &&
			this.inquiryType === this.VIDEO_INQUIRY_TYPE
		) {
			flag = false;
		}

		let problemValue = this.problemValue; //病情描述
		if(!(problemValue.trim().length >= 10)&&!this.twImgShow.filter((v) => v !== "").length){
			flag = false;
		}
		// if (!problemValue) {
		// 	flag = false;
		// } else if (problemValue.trim().length < 10) {
		// 	flag = false;
		// }

		// 图文，视频，网络门诊，未选择初、复诊
		if (this.isShowAcography && this.acographyType === "") {
			flag = false;
		}

		// 选了复诊未上传一张图片
		// if (
		// 	this.acographyType === this.VISIT_TYPE_SECOND_CODE &&
		// 	this.twImgShow.filter((v) => v !== "").length === 0
		// ) {
		// 	flag = false;
		// }

		if (this.inquiryType === this.SPEED_INQUIRY_TYPE) {
			if (this.PARAM_SPEED["deptMustRule"] === 1 && !this.quickDept) {
				// 未选择科室
				flag = false;
			}
			if (this.PARAM_SPEED["priceModel"] !== 0 && !this.quickTitleLevel) {
				// 未选择医生职称等级
				flag = false;
			}
		}

		return flag;
	}

	get acographyTypeText() {
		switch (this.acographyType) {
			case this.VISIT_TYPE_FIRST_CODE:
				return this.$t("im.both"); // '初诊';
				break;
			case this.VISIT_TYPE_SECOND_CODE:
				return this.$t("im.visit"); // '复诊';
				break;
			default:
				return "";
		}
	}

	// set problemValue(val) {
	// 	if (val.length > 300) {
	// 		// emoji在ios占两位字符长度，maxLength认为是1个
	// 		this.problemValue = this.problemValue.substring(0, 300);
	// 	}
	// 	this.$store.dispatch("ACTION_INTER_SET_DATA", {
	// 		name: "problemValue",
	// 		value: val,
	// 	});
	// }

	// 上传图片时，存上传成功后返回的url，留给提交订单时入参使用
	get twImg() {
		return this.$store.state.interrogation.twImg;
	}

	get twImgShow() {
		return this.$store.state.interrogation.twImgShow
	}

	// 获取store里面用户信息的数据
	get userInfo() {
		return this.$store.state.userInfo;
	}

	get isEn() {
		return this.$store.getters[StoreType.IS_LANG_EN];
	}

	// 视频的排班分时信息
	get videoTimeString() {
		if (!this.timeShare.scheduleDetailStartTime) {
			return "";
		}
		return (
			Public.parseTime(
				this.timeShare.scheduleDate,
				`{m}${this.isEn ? "." : this.$t("common.month")}{d}${
					this.isEn ? "" : this.$t("common.day")
				} `,
				false
			) +
			this.timeShare.scheduleDetailStartTime +
			"-" +
			this.timeShare.scheduleDetailEndTime
		);
	}

	//总费用
	get totalFee() {
		if (this.inquiryType === Cons.PICTURE_INQUIRY_TYPE) {
			return this.doctorMsg.totalFee  //  textInquiryPrice;
		}
		return;
		if (this.inquiryType === Cons.VIDEO_INQUIRY_TYPE) {
			return this.doctorMsg.videoInquiryPrice;
		}
		if (this.inquiryType === this.VISIT_INQUIRY_TYPE) {
			return this.timeShare.treatFee;
		}
		if (this.inquiryType === this.PHONE_INQUIRY_TYPE) {
			return this.doctorMsg.voiceInquiryPrice;
		}
		if (this.inquiryType === this.SPEED_INQUIRY_TYPE) {
			if (this.PARAM_SPEED["priceModel"] === 0) {
				return this.PARAM_SPEED["price"] || 0;
			} else {
				switch (this.quickTitleLevel.dictCode) {
					case "231": // 主任医师
						return this.PARAM_SPEED["directorUnitPrice"] || 0;
					case "232": //副主任医师
						return this.PARAM_SPEED["deputyDirectorUnitPrice"] || 0;
					case "233": //主治医师
						return this.PARAM_SPEED["chargeDoctorUnitPrice"] || 0;
					case "234": //医师
						return this.PARAM_SPEED["normalDoctorUnitPrice"] || 0;
					default:
						return 0;
				}
			}
		}
		return 0;
	}

  // 当前科室
  get currentDepartment() {
    return this.$store.state.doctor.currentDepartment
  }


	async created() {
		// Wechat.getJsApiTicket();
		if (utils.isNotNull(this.currentPatient)) {
			apis.ov
				.detailLastTime({ patientId: this.currentPatient.patientId })
				.then((res) => {
					this.chief = res.data.chief;
					this.urls = res.data.urls;
					this.fileId = res.data.fileId;
					if (this.chief && this.chief.length) {
						this.isLastDescClose = false;
					}
				});
		}

		this.doctorMsg = this.$store.state.interrogation.doctorMsg || {};

		let quickTitleLevel: any = this.$route.query.quickTitleLevel;
		let quickDept: any = this.$route.query.quickDept;

		quickTitleLevel && (this.quickTitleLevel = JSON.parse(quickTitleLevel));
		quickDept && (this.quickDept = JSON.parse(quickDept));

		this.quickTitle_index = Cons.DOCTOR_TITLE_LIST.findIndex((item) => {
			return (
				this.quickTitleLevel &&
				item.dictCode === this.quickTitleLevel.dictCode
			);
		});

		if (this.inquiryType !== this.SPEED_INQUIRY_TYPE) {
			// this.getDepts();
		} else {
			// 医生职称和极速咨询价格对应起来
			this.doctorTitleOptions = Cons.DOCTOR_TITLE_LIST.map((item) => {
				let price = 0;
				switch (item.dictCode) {
					case "231": // 主任医师
						price = this.PARAM_SPEED["directorUnitPrice"] || 0;
						break;
					case "232": //副主任医师
						price =
							this.PARAM_SPEED["deputyDirectorUnitPrice"] || 0;
						break;
					case "233": //主治医师
						price = this.PARAM_SPEED["chargeDoctorUnitPrice"] || 0;
						break;
					case "234": //医师
						price = this.PARAM_SPEED["normalDoctorUnitPrice"] || 0;
						break;
					default:
				}
				return {
					...item,
					price,
				};
			});
		}

		let title = this.$t("doctor.pictureConsultation");
		switch (this.inquiryType) {
			case Cons.PICTURE_INQUIRY_TYPE: // 图文问诊
				title = this.$t("doctor.pictureConsultation") as string;
				break;
			// case Cons.VIDEO_INQUIRY_TYPE: // 视频问诊
			// 	title = this.$t("doctor.videoConsultation") as string;
			// 	break;
			// case Cons.PHONE_INQUIRY_TYPE: // 电话问诊
			// 	title = this.$t("doctor.phoneConsultation") as string;
			// 	break;
			// case Cons.VISIT_INQUIRY_TYPE: // 网络门诊
			// 	title = this.$t("doctor.revisit_prescriptions") as string;
			// 	break;
			// case Cons.SPEED_INQUIRY_TYPE: // 极速咨询
			// 	title = this.$t("common.quick_inquiry") + "";
			// 	break;
			// default:
			// 	title = this.$t("doctor.online_consulting") as string; // 在线问诊
			// 	break;
		}

		setTimeout(() => {
			(document as any).title = title;
		}, 10);

		if (
			this.inquiryType === this.SPEED_INQUIRY_TYPE &&
			this.PARAM_SPEED["deptMustRule"] === 1
		) {
			// 是否需要选择科室
			await this.getVirtualDeptList();
			this.quickDept_index = this.virtualDeptList.findIndex((item) => {
				return (
					this.quickDept &&
					item.departmentId === this.quickDept.departmentId
				);
			});
		}
	}

	textIChange() {}

	//  查询开启极速咨询的科室
	async getVirtualDeptList() {
		const res = await apis.om.virtualDeptList({
			queryType: 7,
		});
		let data = res.data;
		if (res.data) {
			this.virtualDeptList = res.data;
		}
	}

	// 查询医生所在虚拟科室
	async getDepts() {
		let queryType = Cons.deptQueryType.inquiry; // 默认查在线咨询
		if (this.inquiryType === this.VISIT_INQUIRY_TYPE) {
			// 网络门诊
			queryType = Cons.deptQueryType.clinic;
		}

		let param = {
			queryType,
			tenantId: this.currentHospital.tenantId,
			employeeId: this.doctorMsg.employeeId,
		};
		let res = await Api.om.doctorDeptList(param);
		if (res.data) {
			res.data.sort((a, b) => {
				if (a.departmentId === this.$route.query.departmentId)
					return -1;
				return 0;
			});
			this.depts = res.data;
			this.departmentId = this.depts[0].departmentId;
			this.currentDept = this.depts[0];
		}
	}

	// 重新选择号源分时
	handleChooseTimeShare(item) {
		// 问诊确认页查询排班的接口可能没有  treatFee  scheduleModel ，使用上一个页面存储的值
		if (!item.treatFee) {
			item.treatFee = this.timeShare.treatFee;
		}
		if (!item.scheduleModel) {
			item.scheduleModel = this.timeShare.scheduleModel;
		}
		this.$store.commit(StoreType.MUTATION_TIMESHARE, item);
		this.showSchedule = false;
	}

	// 打开选择号源分时弹框
	async openChooseTimeshare(item) {
		await this.queryScheduleByDept();
		this.showSchedule = true;
	}

	async changeServiceType(name) {
		//判断是否有问诊
		if (utils.isNotNull(this.currentPatient) && this.isTextArrange) {
			const res = await apis.ov.isRepeatInquiry({
				tenantId: this.currentHospital.tenantId,
				apptDate: this.timeShare.scheduleDate,
				patientId: this.currentPatient.patientId,
				departmentId: this.currentDept.departmentId,
				doctorCode: this.doctorMsg.employeeId,
				inqueryType: name,
			});
			if (res.data && res.data.flag) {
				// '该就诊人已预约' + this.scheduling.schedule.scheduleDate + '号源,请勿重复预约'
				this.$pascToast(
					this.$t(`im.no_repeat`, { a: this.timeShare.scheduleDate })
				);
			}
		}
	}

	// 选择就诊人
	choiceCard() {
		// 切换就诊人
		this.$store.commit(
			StoreType.MUTATION_CERTIFICATION_PATH,
			this.$route.fullPath
		);
		let obj: any = {
			name: Routers.PATIENT_PATIENT_LIST, //PATIENT_CARD_SELECT,
			query: {
				inquiryType: this.inquiryType,
			},
		};
		if (!this.isNeedJzk) {
			//当前医院不需要绑定就诊卡
			obj.query.people = "1";
		}
		this.$router.push(obj).catch(err =>{console.log(err)});
	}

	chooseImage() {
		console.log('chooseImage--------',)
		let nativeChoose = () => {
			let input = document.createElement("input");
			input.style.position = "absolute";
			input.style.left = "-9999px";
			input.style.top = "-9999px";
			input.type = "file";
			input.accept = "image/*";
			// input.multiple = true;
			document.body.appendChild(input);
			input.onchange = this.pictureChange;
			input.click();
		};
		if (
			!utils.isWeixin() ||
			Utils.getSessionCache(Cons.LOGIN_TYPE) === "ticket"
		) {
			nativeChoose();
		} else {
			const len = this.twImg ? this.twImg.length : 0;
			const photoCount = 4 - len;
			Wechat.chooseImage(photoCount)
				.then((res) => {
					console.log(res,'++++++++++++')
					this.pictureChange(res);
				})
				.catch((err) => {
					nativeChoose();
					console.log("选择图片报错", err);
				});
		}
	}
	// 上传图片事件
	async pictureChange(e) {
		const _this = this;
		let files = e instanceof Event ? (e.srcElement as any).files : e;
		const len = this.twImg ? this.twImg.length : 0;
		if (len + files.length > 4) {
			this.$toast(this.$t("im.uploadImgLimit"));
			return false;
		}
		for (let i = 0, len = files.length; i < len; i++) {
			let file = files[i];
			console.log(file,"+++++++++++++++++++++++++++++++++")
			try {
				let twImgShowClone = _this.twImgShow.slice(0);
				let currentIndex = twImgShowClone.length;
				if (file && file.size < 1024 * 1024 * 18) {
					twImgShowClone.push("");
					_this.$store.commit(MUTATION_INTER_SET_DATA, {
						name: "twImgShow",
						value: twImgShowClone,
					});
				}
				const fd = new FormData();
				fd.append('file', file);
				const res=await apis.ov.uploadFile(
					fd
				)
				// const res = await Api.oss.uploade(
				// 	file,
				// 	"auth",
				// 	new CancelToken(function (cancel) {
				// 		_this.cancelFnArr[currentIndex] = cancel;
				// 	})
				// );
				if (res && res.data) {
					let reader = new FileReader();
					reader.readAsDataURL(file);
					let _this=this
					reader.onload = function (e) {
						// 图片base64化
						let localUrl = this.result,
							twImgShowClone = _this.twImgShow.slice(0);
						twImgShowClone.splice(currentIndex, 1, localUrl);

						_this.$store.commit(MUTATION_INTER_SET_DATA, {
							name: "twImgShow",
							value: twImgShowClone,
						});
					};
					let twImgClone = this.twImg.slice(0);
					twImgClone.push(
						res.data
						// res.data.serverUrl +
						// 	"@@" +
						// 	res.data.fileId +
						// 	"@@" +
						// 	res.data.fileName
					);
					console.log(twImgClone)
					this.$store.commit(MUTATION_INTER_SET_DATA, {
						name: "twImg",
						value: twImgClone,
					});
				}
			} catch (error) {
				console.log("catch");
				console.log(error);
			}
		}
	}

	closeConsult() {
		this.showConsultTip = false;
	}

	// 预览图片大小
	scanImg(item, index) {
		if (!item) return;
		let images = this.twImgShow.reduce((res, cur) => {
			let urlAuth = urlAuthBg(cur);
			res.push(urlAuth);
			return res;
		}, []);
		ImagePreview({
			images,
			startPosition: index,
			closeOnPopstate: true,
		});
	}

	// 删除图片
	async deleteImg(item, index) {
		let twImgClone = this.twImg.slice(),
			twImgShowClone = this.twImgShow.slice();
		twImgClone.splice(index, 1);
		twImgShowClone.splice(index, 1);
		let cancelFn = this.cancelFnArr.splice(index, 1)[0];
		if (typeof cancelFn === "function") {
			cancelFn("取消上传");
		}

		this.$store.commit(MUTATION_INTER_SET_DATA, {
			name: "twImg",
			value: twImgClone,
		});
		this.$store.commit(MUTATION_INTER_SET_DATA, {
			name: "twImgShow",
			value: twImgShowClone,
		});
	}

	// 下单
	goSubmit() {
		// 未选择就诊人
		if (utils.isNull(this.currentPatient)) {
			this.$toast(this.$t("im.choosePatient"));
			return false;
		}

		// 未选择初复诊
		if (this.isShowAcography && this.acographyType === "") {
			this.$toast(this.$t("common.select_type"));
			return;
		}

		if (this.inquiryType === this.SPEED_INQUIRY_TYPE) {
			if (this.PARAM_SPEED["deptMustRule"] === 1 && !this.quickDept) {
				// 未选择科室
				this.$toast(this.$t("common.quick_dept_tip"));
				return;
			}
			if (this.PARAM_SPEED["priceModel"] !== 0 && !this.quickTitleLevel) {
				// 未选择医生职称等级
				this.$toast(this.$t("common.quick_title_tip"));
				return;
			}
		}

		let problemValue = this.problemValue;
		if(this.twImgShow.filter((v) => v !== "").length||problemValue){
			if (problemValue&&problemValue.trim().length < 10) {
			this.$toast(this.$t("im.contentLimit"));
			return false;
		}
		}else{
			this.$toast(this.$t("im.enterDes"));
			return;
		}
		// if (
		// 	this.acographyType === this.VISIT_TYPE_SECOND_CODE &&
		// 	this.twImgShow.filter((v) => v !== "").length === 0
		// ) {
		// 	// 请至少上传一张图片
		// 	this.$toast(this.$t("im.upload_least"));
		// 	return;
		// }

		if (this.inquiryType === Cons.VISIT_INQUIRY_TYPE) {
			// 网络门诊下单
			this.netClinicOrder();
			return;
		}

		if (this.inquiryType === Cons.SPEED_INQUIRY_TYPE) {
			// 极速咨询
			this.speedInquiryOrder();
			return;
		}

		if (
			this.isTextArrange &&
			!this.videoTimeString &&
			this.inquiryType === this.VIDEO_INQUIRY_TYPE
		) {
			// 视频问诊未选择问诊时间
			this.$pascToast(this.$t("common.select_v_time"));
			return;
		}

		this.goCreateOrder();
	}

	// 校验通过，生成订单
	async goCreateOrder() {
		try {
			let params: any = {
				patientId: this.currentPatient.patientId,
				patientName: this.currentPatient.patientName,
				tenantId: this.currentHospital.tenantId,
				tenantName: this.currentHospital.hospitalName,
				hospitalId: this.currentHospital.tenantId,
				departmentId: this.currentDepartment.departmentId, //this.currentDept.departmentId,
				departmentName: this.currentDepartment.departmentName, //this.currentDept.departmentName,
				doctorCode: (this.doctorMsg as any).employeeId,
				chief: this.problemValue,
				urls: this.twImg,
				acographyType: this.acographyType,
				totalFee: this.totalFee,  
				allowCallBefore: this.isAllowCallAhead ? 1 : 0,
			};

			// 需要传排班信息的三种情况
			if (
				this.isTextArrange ||
				this.isPhoneArrange ||
				this.inquiryType === Cons.VIDEO_INQUIRY_TYPE
			) {
				let obj = {
					scheduleId: this.timeShare.scheduleId,
					periodId: this.timeShare.schedulePeriodId, //排班分时id
					shiftCode: String(this.timeShare.scheduleTime), //班别0 上午 1下午
					videoPeriod:
						this.timeShare.scheduleDetailStartTime +
						"-" +
						this.timeShare.scheduleDetailEndTime,
					videoDate: this.timeShare.scheduleDate,
				};
				params = {
					...params,
					...obj,
				};
			}

			let res;
			if (this.inquiryType === Cons.PICTURE_INQUIRY_TYPE) {
				res = await apis.ov.addInterOrder(params);
			}
			// if (this.inquiryType === Cons.VIDEO_INQUIRY_TYPE) {
			// 	res = await apis.ov.videoConsultation(params);
			// }
			// if (this.inquiryType === Cons.PHONE_INQUIRY_TYPE) {
			// 	res = await apis.ov.callVisitOrder(params);
			// }

			let paySetting: any = {};
			if (res.data) {
				if (res.data.flag) {
					const { patientName, doctorName, inqueryId, isPayFlag } =
						res.data;
					this.patientName = patientName;
					this.doctorName = doctorName;
					this.inqueryId = inqueryId;
					this.showConsultTip = true;
					this.payShow = isPayFlag;
				} else {
					const { data } = res;
					const interIM = {
						type: 1,
						inqueryId: data.inqueryId,
						patientId: this.currentPatient.patientId,
						patientName: this.currentPatient.patientName,
						sex: this.currentPatient.sex,
						problemValue: this.problemValue,
						imgList: this.twImg,
						blList: [], // 病历列表，目前没用到
						orderNo: data.orderNo,
					};
					this.$store.commit(MUTATION_INTER_INTERIM, interIM);

					// 提交仓库
					paySetting = {
						bizCode: "",
						orderContext: data.orderContext,
						orderAmount: data.fee,
						outTime: data.outTime,
						orderTime: data.orderTime,
						saveTime: +new Date(),
						outTradeNo: data.orderNo, // 订单号
						body: "支付", // 商品描述
						tenantId: this.currentHospital.tenantId || "",
						addDate: data.addDate,
						queueNo: res.data.queueNo,
						cancelTime: res.data.cancelTime,
					};
					this.$store.commit(
						StoreType.MUTATION_PAY_SETTING,
						paySetting
					);
				}
			} else if (res.errorCode === "OV1001") {
				this.$toast(this.$t("im.docNotOpen"));
			}
			if (res.errorCode === "OV1117") {
				// 当前选择的排班已过期或已约满，请选择其他号源
				this.$pascToast(this.$t("common.yi_man"));
				this.isQueryArrangeAgain = true;
				this.$store.commit(StoreType.MUTATION_TIMESHARE, {});
				return;
			}

			//下单成功删除图文问诊的图片，输入的内容
			this.problemValue = "";
			this.$store.commit(MUTATION_INTER_SET_DATA, {
				name: "twImg",
				value: [],
			});
			this.$store.commit(MUTATION_INTER_SET_DATA, {
				name: "twImgShow",
				value: [],
			});
			let nextRouter = Routers.PAY_INTER_PAY_RES;
      // 0元订单，下单成功后直接跳成功页面
    //   if(Number(res.data.fee) === 0){
    //       // 免费  先直接跳支付然后点按钮过去测试聊天
    //     //   this.$router.replace({
    //     //       name: 'paySuccess'
    //     //   })
	// 	   this.$router.replace({
    //           name: 'PayInterPay',
    //           query: {
    //             orderNo: res.data.orderNo, // 订单号
    //             price: res.data.fee, // 金额
    //             childClinicId: '',  // 未知的微信下单需要入参
    //             inqueryId: res.data.inqueryId, // 问诊下单成功后返回的问诊id
    //           }
    //       }) 
    //   } else {
    //       // 非0元订单跳转在线问诊支付页面
    //       this.$router.replace({
    //           name: 'PayInterPay',
    //           query: {
    //             orderNo: res.data.orderNo, // 订单号
    //             price: res.data.fee, // 金额
    //             childClinicId: '',  // 未知的微信下单需要入参
    //             inqueryId: res.data.inqueryId, // 问诊下单成功后返回的问诊id
    //           }
    //       }) 
    //   }
      
			// if(this.isTextArrange && this.isInquiryShowQueue){ // 三亚版本的下单成功页
			//     nextRouter = Routers.APPOINTMENT_RES;
			// }
			// console.log({
			// 		orderCode: paySetting.outTradeNo,
			// 		orderAmount: paySetting.orderAmount,
			// 		businessType: "4",
			// 		tenantId: paySetting.tenantId,
			// 		hospitalName: this.currentHospital.hospitalName,
			// 		userId: this.$store.state.userInfo.userId,
			// 		addDate: paySetting.addDate,
			// 		outTime: paySetting.outTime,
			// 		freePay: Routers.INTER_INQUIRY_ORDER_LIST,
			// 	},'-----------')
			// 	let payParam = ""
            //   for (let item in paySetting){
            //       payParam+="&" + item + "=" + encodeURIComponent(paySetting[item])
            //   }
    		//               Wechat.navigateToPay(payParam)


			// 发起支付
			this.$store.dispatch(StoreType.ACTION_PAY, {
				nextRouter,
				query: {
					orderCode: paySetting.outTradeNo,
					orderAmount: paySetting.orderAmount,
					businessType: "4",
					tenantId: paySetting.tenantId,
					hospitalName: this.currentHospital.hospitalName,
					userId: this.$store.state.userInfo.userId,
					addDate: paySetting.addDate,
					outTime: paySetting.outTime,
					freePay: Routers.INTER_INQUIRY_ORDER_LIST,
				},
				isReplace: true,
				callbackFn: () => {
					this.payVisiable = true;
				},
			});
		} catch (error) {
			console.log(error);
		}
	}

	// 网络门诊下单
	async netClinicOrder() {
		let params = {
			doctorCode: this.doctorMsg.employeeId,
			scheduleId: this.timeShare.scheduleId,
			periodId: this.timeShare.schedulePeriodId,
			shiftCode: this.timeShare.scheduleTime,
			patientId: this.currentPatient.patientId,
			totalFee: this.timeShare.treatFee,
			patientName: this.currentPatient.patientName,
			hospitalId: this.doctorMsg.hospitalId,
			tenantId: this.doctorMsg.hospitalId,
			tenantName: this.currentHospital.hospitalName,
			apptDate: this.timeShare.scheduleDate,
			apptStartTime: this.timeShare.scheduleDetailStartTime,
			apptEndTime: this.timeShare.scheduleDetailEndTime,
			acographyType: this.acographyType,
			urls: this.twImg,
			settleType: "0", // 自费
			departmentId: this.currentDept.departmentId,
			departmentName: this.currentDept.departmentName,
			scheduleModel: this.timeShare.scheduleModel,
			chief: this.problemValue,
			hisDepartmentId: this.timeShare.hisDepartmentId,
		};

		const toast = Toast.loading({
			duration: 0, // 持续展示 toast
			forbidClick: true,
			message: this.$t("order.creating") as string, // 正在创建订单
		});
		try {
			const res = await Api.ov.netOutpatient(params);
			toast.clear();
			if (res && res.data) {
				if (res.data.flag) {
					const { patientName, doctorName, inqueryId, isPayFlag } =
						res.data;
					this.patientName = patientName;
					this.doctorName = doctorName;
					this.inqueryId = inqueryId;
					this.showConsultTip = true;
					this.payShow = isPayFlag;
				} else {
					//下单成功
					this.inqueryId = res.data.inqueryId;
					this.goPay(res.data);
				}
			}
		} catch (e) {}
	}

	async speedInquiryOrder() {
		let param = {
			patientId: this.currentPatient.patientId,
			patientName: this.currentPatient.patientName,
			pubAccountsType: this.isOrg ? "1" : "2", // 公众号类型(1区域版 2单体版)
			departmentId: this.quickDept ? this.quickDept.departmentId : "",
			departmentName: this.quickDept ? this.quickDept.departmentName : "",
			tenantId: !this.isOrg ? this.currentHospital.tenantId : "",
			tenantName: !this.isOrg ? this.currentHospital.hospitalName : "",
			doctorTitleCode: this.quickTitleLevel.dictCode,
			doctorTitleName: this.$t(this.quickTitleLevel.dictName) + "",
			totalFee: this.totalFee,
			chief: this.problemValue,
			urls: this.twImg,
		};
		let res = await Api.ov.speedInquiryOrder(param);
		if (res.data) {
			const interIM = {
				inqueryId: res.data.inqueryId,
				orderNo: res.data.orderNo,
			};
			this.$store.commit(StoreType.MUTATION_INTER_INTERIM, interIM);
			goPay(res.data, Routers.SI_PAY_RES, true);
		}
	}

	goPay(item) {
		const interIM = {
			type: 1,
			inqueryId: item.inqueryId,
			patientId: this.currentPatient.patientId,
			patientName: this.currentPatient.patientName,
			sex: this.currentPatient.sex,
			imgList: this.twImg,
			orderNo: item.orderNo,
		};

		this.$store.commit(StoreType.MUTATION_INTER_INTERIM, interIM);
		//下单成功删除图片，输入的内容
		this.problemValue = "";
		this.$store.commit(MUTATION_INTER_SET_DATA, {
			name: "twImg",
			value: [],
		});
		this.$store.commit(MUTATION_INTER_SET_DATA, {
			name: "twImgShow",
			value: [],
		});

		const paySetting = {
			bizCode: item.businessCode,
			businessType: item.businessType,
			orderContext: item.orderContext,
			orderAmount: Number(item.fee).toFixed(2),
			orderTime: item.orderTime,

			outTradeNo: item.orderNo,
			body: "支付", // 商品描述
			tenantId: item.tenantId || "",
			inqueryId: item.inqueryId,
		};
		this.$store.commit(StoreType.MUTATION_PAY_SETTING, paySetting);
		// 发起支付
		this.$store.dispatch(StoreType.ACTION_PAY, {
			nextRouter: Routers.PAY_INTER_PAY_RES,
			query: {
				orderCode: paySetting.outTradeNo,
				orderAmount: paySetting.orderAmount,
				businessType: paySetting.businessType,
				tenantId: paySetting.tenantId,
				hospitalName:
					this.$store.state.hospital.currentHospital.hospitalName,
				userId: this.$store.state.userInfo.userId,
				addDate: item.orderTime,
				outTime: item.outTime,
				freePay: Routers.INTER_INQUIRY_ORDER_LIST,
			},
			callbackFn: () => {
				this.payVisiable = true;
			},
		});
	}

	handleConfirm() {
		this.$router.replace({
			name: Routers.INTER_INQUIRY_ORDER_LIST,
		});
	}

	switchDept(index) {
		this.currentDept = this.depts[index];
		this.departmentId = this.currentDept.departmentId;
		this.queryScheduleByDept();
	}

	async queryScheduleByDept() {
		let departmentId = this.currentDept.departmentId;
		let scheduleType;
		switch (this.inquiryType) {
			case Cons.PICTURE_INQUIRY_TYPE:
			case Cons.VIDEO_INQUIRY_TYPE:
			case Cons.PHONE_INQUIRY_TYPE:
				scheduleType = 0;
				break;
			case Cons.VISIT_INQUIRY_TYPE:
				scheduleType = 4;
				break;
			default:
		}
		let params = {
			tenantId: this.currentHospital.tenantId,
			employeeId: this.doctorMsg.employeeId,
			departmentId,
			scheduleType,
		};
		let res = await apis.om.scheduleArrangeList(params);
		this.schedulingList = res.data;
		this.isQueryArrangeAgain = false;
	}

	async choiceTime() {
		if (this.isQueryArrangeAgain) {
			await this.queryScheduleByDept();
		}
		this.showSchedule = true;
	}

	// 查看详情
	getDetail() {
		this.$router.push({
			name: Routers.INTER_IM,
			query: {
				inqueryId: this.inqueryId,
			},
		});
	}

	goAutoFill() {
		this.isLastDescClose = true;
		this.problemValue = this.chief;
		if (this.urls && this.urls.length) {
			let imgArrSubmit = this.urls.reduce((res, cur, i) => {
				let str = cur.replace(
					new RegExp("(" + this.fileId[i] + ")"),
					function ($0, $1) {
						return "@@" + $1 + "@@" + +new Date() + ".jpg"; // fileName 可以随便生成
					}
				);
				res.push(str);
				return res;
			}, []);
			this.$store.commit(MUTATION_INTER_SET_DATA, {
				name: "twImg",
				value: imgArrSubmit,
			});
			this.$store.commit(MUTATION_INTER_SET_DATA, {
				name: "twImgShow",
				value: this.urls,
			});
		}
	}

	onShowDocTitle() {
		if (this.doctorTitleOptions.length === 0) {
			// 未维护极速咨询科室
			this.$pascToast(this.$t("patient.no_department"));
			return;
		}
		this.isShowDoctorTitle = true;
		setTimeout(() => {
			if (this.quickTitle_index) {
				let picker_docTitle: any = this.$refs.picker_docTitle;
				picker_docTitle &&
					picker_docTitle.setIndexes([this.quickTitle_index]);
				this.quickTitle_index = "";
			}
		});
	}

	onShowQuickDept() {
		this.isShowQuickDept = true;
		setTimeout(() => {
			if (this.quickDept_index) {
				let picker_quickDept: any = this.$refs.picker_quickDept;
				picker_quickDept &&
					picker_quickDept.setIndexes([this.quickDept_index]);
				this.quickDept_index = "";
			}
		});
	}

	onConfirmDocTitle(value, index) {
		this.isShowDoctorTitle = false;
		this.quickTitleLevel = value;
		// 将当前选择的医生职称等级保存在url parameter
		let query = this.$route.query;
		query["quickTitleLevel"] = JSON.stringify(value);
		let querystring = Public.toQuerystring(query);
		history.replaceState(
			"",
			"",
			location.origin + location.pathname + `?${querystring}`
		);
	}

	onConfirmQuickDept(value, index) {
		this.isShowQuickDept = false;
		this.quickDept = value;
		// 将当前选择的科室保存在url parameter
		let query = this.$route.query;
		let current = {
			departmentId: value.departmentId,
			departmentName: value.departmentName,
		};
		query["quickDept"] = JSON.stringify(current);
		let querystring = Public.toQuerystring(query);
		history.replaceState(
			"",
			"",
			location.origin + location.pathname + `?${querystring}`
		);
	}
}
